import { Flame } from 'lucide-react';
import { cn } from '@/lib/utils';

interface StreakCounterProps {
  count: number;
  size?: 'sm' | 'lg';
  animate?: boolean;
  showSparks?: boolean;
}

export const StreakCounter = ({ 
  count, 
  size = 'sm', 
  animate = false,
  showSparks = false,
}: StreakCounterProps) => {
  const isActive = count > 0;

  return (
    <div
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-bold relative',
        size === 'sm' ? 'px-3 py-1.5 text-sm' : 'px-5 py-3 text-2xl',
        isActive
          ? 'bg-gradient-to-r from-warning/20 to-destructive/20 text-warning'
          : 'bg-muted text-muted-foreground',
        animate && isActive && 'animate-streak-pulse'
      )}
    >
      {/* Spark particles around fire emoji */}
      {showSparks && (
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(8)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-warning rounded-full animate-fire-spark"
              style={{
                left: size === 'sm' ? '18px' : '28px',
                top: '50%',
                animationDelay: `${i * 40}ms`,
                '--spark-angle': `${(i / 8) * 360}deg`,
              } as React.CSSProperties}
            />
          ))}
        </div>
      )}

      <Flame
        className={cn(
          size === 'sm' ? 'w-4 h-4' : 'w-7 h-7',
          isActive && 'text-warning drop-shadow-[0_0_8px_hsl(var(--warning))]',
          animate && 'animate-flame-pulse'
        )}
      />
      <span className={cn(animate && "animate-number-pop")}>
        {count === 0 ? 'Start your streak!' : count}
      </span>
    </div>
  );
};
